export default __webpack_public_path__ + "742da9be512575d63a817dc17e16c132.png";